import { z } from 'zod'

import mxTranslations from '../i18n/messages/es-MX.json'

import { emailSchema } from './emailSchema'

/**
 *  testRide Schema
 */
export const testRideFormSchema = z
  .object({
    date: z.date({
      required_error: 'This is a required field.',
    }),
    time: z.string().trim().min(1, {
      message: 'This is a required field.',
    }),
    firstName: z.string().trim().min(1, {
      message: 'This is a required field.',
    }),
    lastName: z.string().trim().min(1, {
      message: 'This is a required field.',
    }),
    phone: z
      .string()
      .trim()
      .min(1, { message: mxTranslations?.Common?.required_field || 'This is required field.' })
      .max(20, mxTranslations?.Common?.phone_too_long || 'Phone number is too long'),
  })
  .merge(emailSchema)
